module.exports = PostCategoryEditorDirective;

PostCategoryEditorDirective.$inject = [];

function PostCategoryEditorDirective() {
    return {
        restrict: 'E',
        scope: {
            survey: '=',
            attribute: '=',
            postValue: '=',
            available: '=',
            selected: '=',
            form: '=',
            activeSurveyLanguage:'='
        },
        controller: PostCategoryEditorController,
        template: require('./post-category-editor.html')
    };
}
PostCategoryEditorController.$inject = ['$scope', '_'];

function PostCategoryEditorController($scope, _) {
    $scope.toggleParent = toggleParent;
    $scope.selectAll = selectAll;
    $scope.isSelectAll = false;
    $scope.toggleCategory = toggleCategory;
    $scope.hidden = [];
    function activate () {
            groupCategories();
            convertSelected();
            // selecting parent if any children are selected
            _.each($scope.parents, parent => {
                toggleParent(parent);
            })
    }
    activate();

    function groupCategories () {
        $scope.hidden = _.filter($scope.available, category => {
           if (!_.isUndefined(category._ush_hidden) && category._ush_hidden === true) {
               return category;
           }
        });
        $scope.parents = _.filter($scope.available, category => {
            if (!category.parent_id && _.isUndefined(category._ush_hidden)) {
                return category;
            }
        });
    }
    function convertSelected() {
        const selectedButHidden = _.pluck($scope.hidden, 'id');
        const selected = _.pluck($scope.selected, 'id');
        $scope.selected = [...selected, ...selectedButHidden];
    }

    function toggleParent(parent, childId) {
        if (childId) {
            if ($scope.selected.indexOf(childId) === -1) {
                $scope.selected.push(childId);
            } else {
                $scope.selected.splice($scope.selected.indexOf(childId),1);
            }
        }

        if (parent.children && parent.children.length > 0) {
            let selectedChildren = _.chain(parent.children)
                .pluck('id')
                .intersection($scope.selected)
                .value();
            if (selectedChildren.length > 0 && $scope.selected.indexOf(parent.id) === -1) {
                $scope.selected.push(parent.id)
            }
            if (selectedChildren.length === 0 && $scope.selected.indexOf(parent.id) >= 0) {
                $scope.selected.splice($scope.selected.indexOf(parent.id),1);
            }
        }
    }

    function toggleCategory(category) {
        if (!category.children || category.children.length === 0) {
            if ($scope.selected.indexOf(category.id) === -1) {
                $scope.selected.push(category.id)
            } else {
                $scope.selected.splice($scope.selected.indexOf(category.id),1);
            }
        }
    }

    function selectAll() {
        if ($scope.selected.length === $scope.available.length) {
            $scope.selected = [];
        } else {
            $scope.selected = angular.copy($scope.available);
            convertSelected();
        }
    }
}
